import { render, staticRenderFns } from "./WinnerTinyView.vue?vue&type=template&id=4e01f5cf&scoped=true"
import script from "./WinnerTinyView.vue?vue&type=script&lang=js"
export * from "./WinnerTinyView.vue?vue&type=script&lang=js"
import style0 from "./WinnerTinyView.vue?vue&type=style&index=0&id=4e01f5cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e01f5cf",
  null
  
)

export default component.exports